import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const graceSubscriptionsUI = isFeature('grace-subscriptions-ui');

export const hidePeriodFromSubscriptionDetail = isFeature('hide-period-from-subscription-detail');

export const hideTrialFromSubscriptionDetail = isFeature('hide-trial-from-subscription-detail');

export const graceSubscriptionSidebarDetail = isFeature('grace-subscription-sidebar-detail');
